export const routes = {
  root: {
    root: "/",
  },
  admin: {
    root: "/admin",
    dashboard: {
      root: "/admin/dashboard",
    },
    exonn: {
      installations: {
        root: "/admin/exonn/installations",
      },
      epost: {
        root: "/admin/exonn/epost",
        prices: {
          root: "/admin/exonn/epost/prices",
        },
        letters: {
          root: "/admin/exonn/epost/letters",
        },
      },
    },
    administration: {
      root: "/admin/administration",
      system: {
        root: "/admin/administration/system",
      },
      recommendation: {
        root: "/admin/administration/recommendation",
      },
      reminders: {
        root: "/admin/administration/reminders",
      },
      marketing: {
        root: "/admin/administration/marketing",
      },
      debug: {
        root: "/admin/administration/debug",
      },
    },
    bill: {
      root: "/admin/bill",
      account_movements: {
        root: "/admin/bill/account-movements",
      },
    },
    import: {
      root: "/admin/products-import",
    },
    picking: {
      root: "/admin/picking",
    },
    accountingExport: {
      root: "/admin/accounting-export",
    },
    balanceList: {
      root: "/admin/balance-list",
    },
    organizer: {
      overview: {
        root: "/admin/organizer/overview",
      },
      email: {
        root: "/admin/organizer/email",
      },
      calendar: {
        root: "/admin/organizer/calendar",
      },
      notes: {
        root: "/admin/organizer/notes",
      },
      addressbook: {
        root: "/admin/organizer/addressbook",
      },
      tasks: {
        root: "/admin/organizer/tasks",
      },
      projects: {
        root: "/admin/organizer/projects",
      },
      tickets: {
        root: "/admin/organizer/tickets",
      },
    },
  },
};
